import { Component, Input } from '@angular/core';
// TODO: https://git.sys.cigna.com/angular-guild/cigna-nx/issues/567
// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { LatestUpdate } from '@cigna/chcp/dashboard/data-access';
import { MatDialog } from '@angular/material/dialog';
import { NewFeaturesDialogComponent } from '../new-features-dialog/new-features-dialog.component';

@Component({
  selector: 'cigna-new-features',
  templateUrl: './new-features.component.html',
  styleUrls: ['./new-features.component.scss'],
})
export class NewFeaturesComponent {
  @Input() features: LatestUpdate[] = [];

  // eslint-disable-next-line @typescript-eslint/naming-convention
  expanded = false;

  constructor(public dialog: MatDialog) {}

  toggle() {
    this.expanded = !this.expanded;
  }

  open(feature: LatestUpdate) {
    this.dialog.open(NewFeaturesDialogComponent, {
      data: {
        feature,
      },
      autoFocus: false,
      width: '775px',
    });
  }
}
